import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Supprime automatiquement le slash final des URLs (sauf pour la racine "/").
 * Exemple : /serrurier-orleans-45/  →  /serrurier-orleans-45
 *
 * Équivalent SEO d'une redirection 301 côté serveur :
 * - Google détecte le changement d'URL et consolide vers l'URL canonique
 * - Évite la duplication de contenu dans Google Search Console
 * - replace: true → ne pollue pas l'historique du navigateur
 */
const TrailingSlashRedirect = () => {
    const { pathname, search, hash } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (pathname.length > 1 && pathname.endsWith("/")) {
            const clean = pathname.replace(/\/+$/, "");
            navigate(`${clean}${search}${hash}`, { replace: true });
        }
    }, [pathname, search, hash, navigate]);

    return null;
};

export default TrailingSlashRedirect;
